<template>
    <div class="app_view">
        <van-nav-bar
            :title="language.feedback_record"
            @click-left="onClickLeft"
            fixed
            placeholder
        >
            <span class="head_record" slot="left">
                <van-icon name="arrow-left" size="20px" color="#323233"/>
            </span>
        </van-nav-bar>
        <div class="content bgcolor">
            <template v-if="failsbtn">
                <failed_load></failed_load>
            </template>
            <van-overlay :show="getDataLoading">
                <div style="display: flex;align-items: center;justify-content: center;height: 100%;">
                    <van-loading />
                </div>
            </van-overlay>
            <template v-if="+list.length">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    @load="getdata"
                    >
                    <div class="record_view" @touchstart="touchStart" @touchend="touchEnd($event,item,2)" v-for="item in list">
                        <div class="record_time">
                            <span>{{item.createTime}}</span>
                            <span :class="[+item.replyContentList.length?'replied':'Awaiting_reply']">{{+item.replyContentList.length?language.already_reply:language.awaiting_reply}}</span>
                        </div>
                        <div class="record_text">
                           {{item.content}}
                        </div>
                        <div class="record_img" v-if="+item.imgList.length">
                            <van-image
                                v-for="(imgsrc,imgindex) in item.imgList"
                                :key="item+'01'"
                                width="32%"
                                height="32%"
                                fit="cover"
                                radius="8"
                                @click.stop="lookImg(item.imgList,imgindex)"
                                :src="imgsrc"
                            >
                                <template slot="loading">
                                    <van-loading type="spinner" size="20" />
                                </template>
                            </van-image>
                        </div>
                    </div>
                </van-list>
            </template>
            <template v-else-if="!getDataLoading&&list.length==0">
                <div class="nodata">
                    <img :src="nodataImg" alt="">
                    <div class="textcolor">{{language.no_records_available_at_the_moment}}</div>
                </div>
            </template>
        </div>
        <feedbackDetails @closeDetails="()=>{showdetails=false}" v-if="showdetails" :details="details" ></feedbackDetails>
        <van-image-preview v-model="showImg" :images="imagesList">
        </van-image-preview>
    </div>
  </template>
  <script>
    import { h5list} from "../../../utils/api";
    import { getLangue } from "@/utils/language.js"
    import  feedbackDetails  from "../feedbackDetails/index.vue"
    import  failed_load  from "../404/index.vue"
    export default {
        props: [],
        components: {
            feedbackDetails,
            failed_load
        },
        data() {
        return {
            getDataLoading:false,
            language: getLangue(),
            imagesList:[],
            showImg:false,
            loading:false,
            finished:false,
            startPosition:0,
            pageDate:{
                page:1,
                limit:10
            },
            list:[],
            hasData:true,
            nodataImg:require('../../../static/img/nodata.png'),
            showdetails:false,
            delta: 50, //滑动判断
			touchStartX: 0, // 触屏起始点x
			touchStartY: 0, // 触屏起始点y
        };
        },
        computed: {
            failsbtn(){
                return this.$store.state.failsbtn; // 获取状态
            }
        },
        created(){
            this.getdata()
            this.getDataLoading = true;
            setTimeout(()=>{
                this.getDataLoading = false;
            },10000)
        },
        methods: {
            touchStart(e) {
                console.log('触摸开始');
                this.touchStartX = e.touches[0].clientX;
                this.touchStartY = e.touches[0].clientY;
            },

            /**
             * 触摸结束
             * type用来区分哪个页面的点击事件
             **/
            touchEnd(e, item, type) {
                // console.log('func', func)
                // debugger;
                e.preventDefault(); // 3.阻止默认行为，不阻止事件冒泡
                // console.log('触摸结束');
                let deltaX = e.changedTouches[0].clientX - this.touchStartX;
                let deltaY = e.changedTouches[0].clientY - this.touchStartY;
                // X轴的滑动距离大于 delta，且此次事件是以X轴移动为主（左滑或者右滑）；
                if (Math.abs(deltaX) > this.delta && Math.abs(deltaX) > Math.abs(deltaY)) {
                    if (deltaX >= 0) {
                        console.log('右滑');
                    } else {
                        console.log('左滑');
                    }
                    // Y轴的滑动距离大于 delta，且此次事件是以Y轴移动为主（上滑或者下滑）；
                } else if (Math.abs(deltaY) > this.delta && Math.abs(deltaX) < Math.abs(deltaY)) {
                    if (deltaY < 0) {
                        console.log('上滑');
                    } else {
                        console.log('下滑');
                    }
                    // 两轴位移都特别小，可以判断是点击
                } else if (Math.abs(deltaY) < 25 && Math.abs(deltaX) < 25) {

                    if (type == 2) {
                       this.detailView(item)
                    } else if (type == 1) {
                    }


                } else {
                    console.log('可能是误触');
                }
            },
            lookImg(e,i){
                this.showImg = true
                this.imagesList = e;
                this.startPosition = i
            },
            getdata() {
                this.finished = true
                h5list(this.pageDate).then((res) => {
                    this.getDataLoading = false;
                    this.pageDate.page+=1
                    this.loading = false
                    if(res.data.list.length>0){
                        this.list.push(...res.data.list)
                        this.finished = false
                    }
                }).catch((e)=>{
                    this.finished = true
                });
            },
            onClickLeft(){
                this.$router.go(-1)
            },
            detailView(e){
                // this.$router.push({name:'feedbackDetails',params:{details:e}})
                // console.log(e)
                this.showdetails =true
                this.details = e;
            }
        },
    };
  </script>
  <style lang="scss" scoped>
  .app_view{
    height: 100vh;
    overflow: hidden;
  }
  .content{
    padding:12px 16px;
    height: calc(100vh - 70px);
    overflow-y: auto;
    position: relative;
  }
  .record_view{
    border-radius: 20px;
    background-color: rgba(0, 0, 0, 0.05);
    padding:14px;
    margin-bottom:20px;
    .record_time{
        display: flex;
        justify-content: space-between;
        margin-bottom:10px;
        .replied{
            color: rgba(71, 175, 62, 1);
        }
        .Awaiting_reply{
            color:rgba(238, 29, 29, 1);
        }
    }
    .record_text{
        color:rgba(119, 119, 119, 1);
        width:100%; 
        white-space: nowrap; 
        overflow: hidden; 
        text-overflow: ellipsis; 
    }
    .record_img{
        display: flex;
        min-height: 100px;
        margin-top:14px;
        align-items: center;
        div{
            margin-right: 2%;
            &:nth-of-type(3){
                margin-right: 0;
            }
        }
    }
  }
  .nodata{
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    img{
        width: 260px;
    }
    div{
        font-size: 18px;
        text-align: center;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/view/feedbackRecord/index.vue